import _ from 'lodash';

const _scopedState = state => _.get(state, 'entities.blacklist', {});

const blacklist = state => _scopedState(state);
const blacklistDictionary = state => _scopedState(state).blacklistDictionary;

export default {
  blacklist,
  blacklistDictionary,
};
